var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoteViewing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FEE7BE",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3 10H17.7C16.2094 10 15 11.1338 15 12.5312V34.4688C15 35.8662 16.2094 37 17.7 37H30.3C31.7906 37 33 35.8662 33 34.4688V12.5312C33 11.1338 31.7906 10 30.3 10ZM24 35.3125C23.0044 35.3125 22.2 34.5584 22.2 33.625C22.2 32.6916 23.0044 31.9375 24 31.9375C24.9956 31.9375 25.8 32.6916 25.8 33.625C25.8 34.5584 24.9956 35.3125 24 35.3125ZM30.3 29.6172C30.3 29.9652 29.9962 30.25 29.625 30.25H18.375C18.0037 30.25 17.7 29.9652 17.7 29.6172V13.1641C17.7 12.816 18.0037 12.5312 18.375 12.5312H29.625C29.9962 12.5312 30.3 12.816 30.3 13.1641V29.6172Z",
    fill: "#FCC35D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteViewing);
export default __webpack_public_path__ + "static/media/remote-viewing.3306a0dc.svg";
export { ForwardRef as ReactComponent };